import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Report from 'powerbi-report-component';

import { postData } from '../dataLib';

import { Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    //toolbar: theme.mixins.toolbar,;
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class IniVentas extends Component {


    constructor(props) {
        super(props);

        this.report = null;

        this.state = {
            token: ''
        }
    }

    handleReportLoad = (report) => {
        this.report = report; // get the report object from callback and store it.
    }

    handleReportRender = (report) => {
        this.report = report; // get the report object from callback and store it.
    }

    componentDidMount = () => {

        if (this.props.user && this.props.user.profile.sub === '795') {

            postData(
                'https://ilusiona-redemptionreports-prod.azurewebsites.net/api/PBI/CreateToken',
                (response) => {
                    this.setState({ ...this.state, token: response.data })
                },
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR updating arqueo'
                    }, 'error-create-token', false, 'sm');
                },
                {
                    workspaceId: '776470de-5903-4f74-b7ea-6f7563f7932e',
                    reportId: '5d552d1d-0f4f-46c8-a25b-5d3040a45a2c',
                    //reportId: '73040bb6-041c-4051-9897-4d9c1846e42c'
                },
                this.props.user,
                true
            );
        }

    }



    render() {

        const { classes } = this.props;

        const reportStyle = {
            height: 800
        };

        if (!this.props.user) {
            return (
                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    <div>Please login</div>
                </div>
            );
        }
        else {
            //"https://app.powerbi.com/reportEmbed?reportId=5d552d1d-0f4f-46c8-a25b-5d3040a45a2c&groupId=776470de-5903-4f74-b7ea-6f7563f7932e&$filterPaneEnabled=False&filter=Centro/id eq 52"
            return (

                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    {this.state.token === '' ?
                        <div>Información/resumen para este usuario</div>
                        :
                        <div>
                            <Report
                                embedType="report"
                                tokenType="Embed"
                                accessToken={this.state.token}
                                embedUrl="https://app.powerbi.com/reportEmbed?reportId=5d552d1d-0f4f-46c8-a25b-5d3040a45a2c&groupId=776470de-5903-4f74-b7ea-6f7563f7932e&$filterPaneEnabled=False"
                                //embedUrl="https://app.powerbi.com/reportEmbed?reportId=73040bb6-041c-4051-9897-4d9c1846e42c&groupId=776470de-5903-4f74-b7ea-6f7563f7932e&$filterPaneEnabled=False&filter=Centro/id in (50, 52, 12)"
                                embedId="5d552d1d-0f4f-46c8-a25b-5d3040a45a2c"
                                //embedId="73040bb6-041c-4051-9897-4d9c1846e42c"
                                permissions="View"
                                style={reportStyle}
                                onLoad={this.handleReportLoad}
                                onRender={this.handleReportRender}

                            />
                            <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                if (this.report) { 
                                    //this.report.fullscreen();
                                    this.report.fullscreen();
                                }
                            }}>
                                Pantalla completa
                            </Button>
                            <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                                if (this.report) { 
                                    //this.report.fullscreen();
                                    this.report.print();
                                }
                            }}>
                                Imprimir
                            </Button>
                        </div>

                    }
                </div>


            );
        }
    };

};

IniVentas.propTypes = {
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(IniVentas));